import React from 'react';
import Header from '../../components/ui/Header';
import SEO from '../../components/SEO';
import HeroSection from './components/HeroSection';
import FeaturedStoresSection from './components/FeaturedStoresSection';
import PromotionsCarousel from './components/PromotionsCarousel';
import LocationInfoSection from './components/LocationInfoSection';
import { generatePageSEO, organizationSchema, localBusinessSchema } from '../../utils/seoData';

const Homepage = () => {
  const seoData = generatePageSEO('homepage', {
    structuredData: [organizationSchema, localBusinessSchema]
  });

  return (
    <>
      <SEO {...seoData} />
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* Hero Section */}
          <HeroSection />
          
          {/* Featured Stores Section */}
          <FeaturedStoresSection />
          
          {/* Promotions Carousel */}
          <PromotionsCarousel />
          
          {/* Location Info Section */}
          <LocationInfoSection />
        </main>

        {/* Footer */}
        <footer className="bg-primary text-primary-foreground py-12">
          <div className="max-w-7xl mx-auto px-4 lg:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Brand */}
              <div className="lg:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="flex items-center justify-center w-24 h-24">
                    <img 
                      src="/images/logo/logo.png" 
                      alt="Estação Marina Logo"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-semibold">Estação Marina</h3>
                  </div>
                </div>
                <p className="text-primary-foreground/80 mb-4 leading-relaxed">
                  Estação: o seu ponto de encontro no Altiplano Leste.
                </p>
                <div className="text-sm text-primary-foreground/60">
                  <p>Av. Altiplano Leste - Marina da Rocha</p>
                  <p>Brasília - DF, CEP 71680-900</p>
                  <p className="mt-2">(61) 99691-9001 | estacaocrdf@gmail.com</p>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-semibold mb-4">Links Rápidos</h4>
                <ul className="space-y-2 text-sm text-primary-foreground/80">
                  <li><a href="/store-directory" className="hover:text-primary-foreground transition-colors">Lojas</a></li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h4 className="font-semibold mb-4">Horário de Funcionamento</h4>
                <ul className="space-y-2 text-sm text-primary-foreground/80">
                  <li>Segunda-feira: 06:00 - 23:00</li>
                  <li>Terça-feira: 06:00 - 23:00</li>
                  <li>Quarta-feira: 06:00 - 23:00</li>
                  <li>Quinta-feira: 06:00 - 23:00</li>
                  <li>Sexta-feira: 06:00 - 23:00</li>
                  <li>Sábado: 06:00 - 23:00</li>
                  <li>Domingo: 06:00 - 23:00</li>
                </ul>
              </div>
            </div>

            <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center text-sm text-primary-foreground/60">
              <p>&copy; {new Date()?.getFullYear()} Estação Marina da Rocha. Todos os direitos reservados.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Homepage;